var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSellerInfoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#21252A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.049 16.703c1.516 0 2.27-.762 2.27-2.292V3.3c0-1.524-.754-2.3-2.27-2.3H5.27C3.754 1 3 1.776 3 3.3v11.11c0 1.531.754 2.293 2.27 2.293h7.779zm-.059-1.18H5.33c-.763 0-1.15-.402-1.15-1.134V3.322c0-.733.387-1.143 1.15-1.143h7.66c.762 0 1.15.41 1.15 1.143v11.067c0 .732-.388 1.135-1.15 1.135zM11.943 5.249c.264 0 .454-.205.454-.461 0-.25-.19-.44-.454-.44H6.39c-.264 0-.461.19-.461.44 0 .256.197.461.461.461h5.552zm0 2.556c.264 0 .454-.205.454-.461 0-.25-.19-.44-.454-.44H6.39c-.264 0-.461.19-.461.44 0 .256.197.461.461.461h5.552zM9.02 10.36c.256 0 .454-.197.454-.446 0-.257-.198-.455-.454-.455H6.39c-.264 0-.461.198-.461.455 0 .249.197.446.461.446h2.63z",
    transform: "translate(-251 -327) translate(16 274) translate(224 38) translate(11 14) translate(0 1)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSellerInfoBlack);
export default __webpack_public_path__ + "static/media/ic_seller_info_black.1022c42c834934be0062ee1a69b999cf.svg";
export { ForwardRef as ReactComponent };